// extracted by mini-css-extract-plugin
module.exports = {"loaderButton":"LoaderButton_loaderButton__7MZzO"};